import * as browserCheck from '../utils/browserCheck.js';

class ShareService {

    static getAbsoluteUrl(relativeUrl) {
        return browserCheck.canUseDom() ? window.location.href : `https://www.loudup.com${relativeUrl}`;
    }

    static getFacebookShareUrl(relativeUrl) {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + this.getAbsoluteUrl(relativeUrl);
    }

    static getTwitterShareUrl(relativeUrl, text='Check out this article:') {
        return `https://twitter.com/share?text=${text}&url=${this.getAbsoluteUrl(relativeUrl)}`;
    }

    static getEmailShareUrl(subject, body) {
        return `mailto:?subject=${subject}&body=${body}`;
    }
}
export default ShareService;